(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-collection-product-grid"]) return;
  try {
    
// Collection infinity scroll pagination script
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    pagination: '#AjaxinatePagination',
    container: '#AjaxinateLoop ul',
    loadingText: 'Loading'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-palette-collection-product-grid"]) return;
  try {
    
// Change product images on swatch hover for after infinity scroll loaded products
function swatchcolor_change(){
  $('.swatch-container ul a').on('mouseover', function() {
    var imageUrl = $(this).data('image-url');
    var $productContainer = $(this).closest('.product-card-wrapper'); // Adjust the selector to match your product container
    var $mainProductImage = $productContainer.find('.main-product-image'); // Adjust the selector for the main product image
    $mainProductImage.attr('src', imageUrl);
    $mainProductImage.attr('srcset', imageUrl);
  });

  $(".swatch-container ul a").mouseout(function(){
    var MasterUrl = $(this).closest('ul').find("a.active_picker").data('image-url');
    var $productContainer = $(this).closest('.product-card-wrapper'); // Adjust the selector to match your product container
    var $mainProductImage = $productContainer.find('.main-product-image'); // Adjust the selector for the main product image
    $mainProductImage.attr('src', MasterUrl);
    $mainProductImage.attr('srcset', MasterUrl);

    /* Display default image on hover*/
    var productId = $(this).data('product');
    var MainMasterUrl = $('.swatch-color-selector').closest('.underline-links-hover').find('#'+productId).text();
    var $defaultProductImage = $productContainer.find('.hover_image');
    $defaultProductImage.attr('src', MainMasterUrl);
    $defaultProductImage.attr('srcset', MainMasterUrl);
    /* Display default image on hover*/
    
  });

  // Script For Change Selected State Of Current Hovered Swatch after infinity scroll loaded products
  $(".swatch-container ul a").mouseenter(function (){
    $(".selected_icon").addClass("hide_icon");
    $(this).children("div.selected_icon").removeClass("hide_icon").addClass("show_icon");
    $(".swatch-container ul a.active_picker").css("border","1px solid #ffffff");
    $(".swatch-container ul a.active_picker div").removeClass("show_icon");
  });

  // Script For Change Selected State Of Swatch To Active Selected after infinity scroll loaded products
  $(".swatch-container ul a").mouseleave(function (){
    $(this).children("div.selected_icon").addClass("hide_icon").removeClass("show_icon");
    $(".selected_icon").removeClass("hide_icon");
    $(".swatch-container ul a.active_picker").css("border","1px solid #212121");
    $(".swatch-container ul a.active_picker div").addClass("show_icon");
  });

  $(".swatch-container ul a.active_picker").mouseenter(function (){
    $(".swatch-container ul a.active_picker").css("border","1px solid #212121");
  });

  $(".swatch-container ul a.active_picker").mouseleave(function (){
    $(".swatch-container ul a.active_picker").css("border","1px solid #ffffff");
  });
}
  
// Collection infinity scroll pagination script
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    pagination: '#AjaxinatePagination',
    container: '#AjaxinateLoop ul',
    loadingText: 'Loading',
    callback: swatchcolor_change
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-page"]) return;
  try {
    
// Our Collections Carousel image slider script
var $ExploreSlider = $(".explore_collection_list");

$ExploreSlider.addClass("owl-carousel").owlCarousel({
  slideSpeed : 300,
  paginationSpeed : 400,
  navigation:true,
  loop:true,
  dots: false,
  rewindNav:true,
  margin:25,
  nav:true,
  responsiveClass:true,
  responsive:{
    0:{
      items:1.5
    },
    480:{
      items:2.5,
      margin:15
    },
    750:{
      items:3.5,
      margin:15
    },
    1025:{
      items:4
    }
  }
});


// Our Projects Carousel image slider script
var $ProjectsListSlider = $(".our_projects_list");

$(window).resize(function() {
  showProjectsListSlider();
});

function showProjectsListSlider() {
  if ($ProjectsListSlider.data("owlCarousel") !== "undefined") {
    if (window.matchMedia('(max-width: 1024px)').matches) {
      initialProjectsListSlider();
    } else {
      destroyProjectsListSlider();
    }
  }
}
showProjectsListSlider();

function initialProjectsListSlider() {
  $ProjectsListSlider.addClass("owl-carousel").owlCarousel({
    slideSpeed : 300,
    paginationSpeed : 400,
    navigation:true,
    loop:true,
    dots: false,
    rewindNav:true,
    margin:25,
    nav:true,
    responsiveClass:true,
    responsive:{
      0:{
        items:1.5
      },
      480:{
        items:2.5,
        margin:15
      },
      750:{
        items:3.5,
        margin:15
      }
    }
  });
}

function destroyProjectsListSlider() {
  $ProjectsListSlider.trigger("destroy.owl.carousel").removeClass("owl-carousel");
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-with-headline"] && !Shopify.designMode) return;
  try {
    
// Whole banner clickable script
// var left_banner_container = document.querySelector(".collection_1st_product");
// $(".collection_1st_product .collection_with_headline_product_media").click(function(){
//    window.location=$(left_banner_container).find("a").attr("href"); 
//    return false;
// });

// var right_banner_container = document.querySelector(".collection_2nd_product");
// $(".collection_2nd_product .collection_with_headline_product_media").click(function(){
//    window.location=$(right_banner_container).find("a").attr("href"); 
//    return false;
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-discover-palette"] && !Shopify.designMode) return;
  try {
    
   // Heading text color change script when Scroll
   discoverHeightValus = $('h2.discover-palette-heading:first-child').height();
   $(window).bind('scroll',function(e){
      var element1Discover = $('h2.discover-palette-heading:first-child')[0].getBoundingClientRect();
      var element2Discover = $('.discover_palette_banner_container .banner div')[0].getBoundingClientRect();
      let intersectionDiscoverTop = Math.max(element1Discover.top, element2Discover.top);
      let intersectionDiscoverBottom = Math.min(element1Discover.bottom, element2Discover.bottom);
      let intersectionDiscoverHeight = Math.max(0, intersectionDiscoverBottom - intersectionDiscoverTop);
      let cssRule = 'height: calc('+discoverHeightValus+'px - ' + intersectionDiscoverHeight + 'px)';
      $('h2.discover-palette-heading + h2').attr("style",cssRule);
  });

  // Carousel image slider for desktop
  var $PaletteSlider = $(".discover_palette_list");
  
  $(window).resize(function() {
    showPaletteSlider();
  });
  
  function showPaletteSlider() {
    if ($PaletteSlider.data("owlCarousel") !== "undefined") {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        initialPaletteSlider();
      } else {
        destroyPaletteSlider();
      }
    }
  }
  showPaletteSlider();
  
  function initialPaletteSlider() {
    $PaletteSlider.addClass("owl-carousel").owlCarousel({
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem : true,
      items: 8,
      navigation:true,
      loop:false,
      dots: false,
      rewindNav:true,
      nav:true,
      responsiveClass:true,
      responsive:{
        1025:{
            items:4
        }
      }
    });
  }
  
  function destroyPaletteSlider() {
    $PaletteSlider.trigger("destroy.owl.carousel").removeClass("owl-carousel");
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-limited-edition"] && !Shopify.designMode) return;
  try {
    
  // var limitedHeightValus = $('.home_limited_edition_section > h2:first-child').height();
  // $(window).bind('scroll',function(e){
  //     var element1Limite = $('.home_limited_edition_section > h2:first-child')[0].getBoundingClientRect();
  //     var element2Limite = $('.limited_edition_heading + .limited_edition_container')[0].getBoundingClientRect();
  //     let intersectionLimiteTop = Math.max(element1Limite.top, element2Limite.top);
  //     let intersectionLimiteBottom = Math.min(element1Limite.bottom, element2Limite.bottom);
  //     let intersectionLimiteHeight = Math.max(0, intersectionLimiteBottom - intersectionLimiteTop);
  //     let cssRule = 'height: calc('+limitedHeightValus+'px  - ' + intersectionLimiteHeight + 'px)';
  //     $('.home_limited_edition_section > h2 +h2').attr("style",cssRule);
  // });

  $(window).bind('scroll', function(e) {
    // Loop through each section
    $('.home_limited_edition_section').each(function() {
        var limitedHeightValus = $(this).find('h2:first-child').height();
        var element1Limite = $(this).find('h2:first-child')[0].getBoundingClientRect();
        var element2Limite = $(this).find('.limited_edition_heading + .limited_edition_container')[0].getBoundingClientRect();
        
        let intersectionLimiteTop = Math.max(element1Limite.top, element2Limite.top);
        let intersectionLimiteBottom = Math.min(element1Limite.bottom, element2Limite.bottom);
        let intersectionLimiteHeight = Math.max(0, intersectionLimiteBottom - intersectionLimiteTop);
        
        let cssRule = 'height: calc(' + limitedHeightValus + 'px - ' + intersectionLimiteHeight + 'px)';
        
        // Apply the CSS to the current section's second h2 element
        $(this).find('h2 + h2').attr("style", cssRule);
    });
  });


  // Whole banner clickable script
  // $(".limited_edition_container").click(function(){
  //    window.location=$(this).find("a").attr("href"); 
  //    return false;
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-lookbook"] && !Shopify.designMode) return;
  try {
    
  /*$(document).ready(function() {
      const textSection = $('.lookbook_gallery');
      $(window).on('scroll', function() {
        const windowHeight = $(window).height();
        const textSectionTop = textSection.offset().top;
        const textSectionBottom = textSectionTop + textSection.outerHeight();
        const scrollAmount = $(window).scrollTop();

        if (scrollAmount + windowHeight >= textSectionTop && scrollAmount <= textSectionBottom) {
          const distanceFromViewportTop = scrollAmount - textSectionTop;
          const parallaxAmount = 0.5;
          const translateY = distanceFromViewportTop * parallaxAmount;
          textSection.css('transform', `translateY(${translateY}px)`);
        }
      });
    });*/

  // LookBook Carousel
  $(document).ready(function() { 
  var owl1 = $('.home-lookbook-list'),
  owlOptions = {
        slideSpeed : 300,
        paginationSpeed : 400,
        singleItem : false,
        items: 8,
        navigation:true,
        loop:false,
        dots: false,
        rewindNav:true,
        pagination: false,
        responsiveClass:true,
         responsive:{
              0:{
                  items:1,
                  nav:true,
                  margin:10
              },
              310:{
                  items:2,
                  nav:true,
                  margin:15
              },
              767:{
                  items:3,
                  nav:true,
                  margin:20
              },
              1025:{
                  items:4,
                  nav:true,
                  margin:25
              },
              1440:{
                  items:4,
                  nav:true,
                  margin:50
              },
          }
      };
  owl1.owlCarousel(owlOptions);		
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-mobile-banner-image"] && !Shopify.designMode) return;
  try {
    
// Whole banner clickable script
$(".mobile_banner_container, .mobile_banner_with_video").click(function(){
   var href = $(this).data("href") || $(this).find("a[href]").attr("href");
   if (href) window.location = href;
   return false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-middlebutton"] && !Shopify.designMode) return;
  try {
    
  // var limitedHeightValus = $('.home_limited_edition_section > h2:first-child').height();
  // $(window).bind('scroll',function(e){
  //     var element1Limite = $('.home_limited_edition_section > h2:first-child')[0].getBoundingClientRect();
  //     var element2Limite = $('.limited_edition_heading + .limited_edition_container')[0].getBoundingClientRect();
  //     let intersectionLimiteTop = Math.max(element1Limite.top, element2Limite.top);
  //     let intersectionLimiteBottom = Math.min(element1Limite.bottom, element2Limite.bottom);
  //     let intersectionLimiteHeight = Math.max(0, intersectionLimiteBottom - intersectionLimiteTop);
  //     let cssRule = 'height: calc('+limitedHeightValus+'px  - ' + intersectionLimiteHeight + 'px)';
  //     $('.home_limited_edition_section > h2 +h2').attr("style",cssRule);
  // });

  $(window).bind('scroll', function(e) {
    // Loop through each section
    $('.home_limited_edition_section').each(function() {
        var limitedHeightValus = $(this).find('h2:first-child').height();
        var element1Limite = $(this).find('h2:first-child')[0].getBoundingClientRect();
        var element2Limite = $(this).find('.limited_edition_heading + .limited_edition_container')[0].getBoundingClientRect();
        
        let intersectionLimiteTop = Math.max(element1Limite.top, element2Limite.top);
        let intersectionLimiteBottom = Math.min(element1Limite.bottom, element2Limite.bottom);
        let intersectionLimiteHeight = Math.max(0, intersectionLimiteBottom - intersectionLimiteTop);
        
        let cssRule = 'height: calc(' + limitedHeightValus + 'px - ' + intersectionLimiteHeight + 'px)';
        
        // Apply the CSS to the current section's second h2 element
        $(this).find('h2 + h2').attr("style", cssRule);
    });
  });


  // Whole banner clickable script
  // $(".limited_edition_container").click(function(){
  //    window.location=$(this).find("a").attr("href"); 
  //    return false;
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-middletext"] && !Shopify.designMode) return;
  try {
    
var maintextblack = $(".video_middletext_maintext_black").height();
var oldScrollY = window.scrollY;
window.addEventListener('scroll', updateElementHeight);
function updateElementHeight() {
  var scrollDirection;
  if(oldScrollY < window.scrollY){
    scrollDirection = 2;
  } else {
    scrollDirection = 1;
  }
  oldScrollY = window.scrollY;
  if(scrollDirection == 1) {
    $('body .video_middletext_maintext_black.start').css({"position":"sticky", "top":"11rem", "height" : "auto", "overflow":"none"});
    $('body .video_middletext_maintext_black.end').css({"position":"sticky", "top":"11rem", "z-index":"1"});
  }
  let element1Rect = $('.video_middletext_maintext_black.start')[0].getBoundingClientRect();
  let element2Rect = $('.video_middletext_inner_section + .video_banner .video_content')[0].getBoundingClientRect();
  let elementMiddle = $('.video_middletext_maintext_black + .video_middletext_maintext_black.middle')[0].getBoundingClientRect();
  if(element2Rect.top > element1Rect.top && element1Rect.top > 0) {
    let intersectionTop = element2Rect.top;
    let intersectionBottom = element1Rect.bottom;
    let intersectionHeight = Math.max(0, intersectionBottom - intersectionTop);
    if(scrollDirection == 2 && elementMiddle.height > 0) {
      let cssRule = 'height: calc('+maintextblack+'px - ' + intersectionHeight + 'px)';
      $('body .video_middletext_maintext_black.start + .video_middletext_maintext_black.middle').attr("style",cssRule);
    }
    if(scrollDirection == 1) {
      let cssRule = 'height: calc('+maintextblack+'px - ' + intersectionHeight + 'px)';
      $('body .video_middletext_maintext_black.start + .video_middletext_maintext_black.middle').attr("style",cssRule);
    }
  } else {
    let cssRule = 'height: 0px';
    // let elementVideoRect = $('.video_middletext_inner_section + .video_banner video')[0].getBoundingClientRect();
    let elementVideoRect = $('.video_middletext_inner_section + .video_banner video, .video_middletext_inner_section + .video_banner img')[0].getBoundingClientRect();
    let homeVideoRect = $('.home-video-middletext')[0].getBoundingClientRect();
    let topElement = 0;
    screen.width <= 1440 ?  topElement = elementVideoRect.top + Math.abs(homeVideoRect.top) + 8.5 : topElement = elementVideoRect.top + Math.abs(homeVideoRect.top) - 56;
    let elementEnd = $('.video_middletext_maintext_black.end')[0].getBoundingClientRect();
    let hDifference = elementEnd.height - elementVideoRect.height;
    let currHeight = elementEnd.height - hDifference - 9;
    $('body .video_middletext_maintext_black + .video_middletext_maintext_black.middle').attr("style",cssRule);
    if ($(window).width() < 2000)
    {
      $('body .video_middletext_maintext_black.start').css({"position":"relative", "top":topElement+"px", "height" : currHeight+"px", "overflow":"hidden"});
    } else {
      $('body .video_middletext_maintext_black.start').css({"position":"relative", "top":topElement+"px",  "overflow":"hidden"});
    }
    $('body .video_middletext_maintext_black.end').css({"position":"relative", "top":topElement+"px", "z-index":"1"});
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
// Change product images on swatch hover for after infinity scroll loaded products
function swatchcolor_change(){
  $('.swatch-container ul a').on('mouseover', function() {
    var imageUrl = $(this).data('image-url');
    var $productContainer = $(this).closest('.product-card-wrapper'); // Adjust the selector to match your product container
    var $mainProductImage = $productContainer.find('.main-product-image'); // Adjust the selector for the main product image
    $mainProductImage.attr('src', imageUrl);
    $mainProductImage.attr('srcset', imageUrl);
  });

  $(".swatch-container ul a").mouseout(function(){
    var MasterUrl = $(this).closest('ul').find("a.active_picker").data('image-url');
    var $productContainer = $(this).closest('.product-card-wrapper'); // Adjust the selector to match your product container
    var $mainProductImage = $productContainer.find('.main-product-image'); // Adjust the selector for the main product image
    $mainProductImage.attr('src', MasterUrl);
    $mainProductImage.attr('srcset', MasterUrl);

    /* Display default image on hover*/
    var productId = $(this).data('product');
    var MainMasterUrl = $('.swatch-color-selector').closest('.underline-links-hover').find('#'+productId).text();
    var $defaultProductImage = $productContainer.find('.hover_image');
    $defaultProductImage.attr('src', MainMasterUrl);
    $defaultProductImage.attr('srcset', MainMasterUrl);
    /* Display default image on hover*/
    
  });

  // Script For Change Selected State Of Current Hovered Swatch after infinity scroll loaded products
  $(".swatch-container ul a").mouseenter(function (){
    $(".selected_icon").addClass("hide_icon");
    $(this).children("div.selected_icon").removeClass("hide_icon").addClass("show_icon");
    $(".swatch-container ul a.active_picker").css("border","1px solid #ffffff");
    $(".swatch-container ul a.active_picker div").removeClass("show_icon");
  });

  // Script For Change Selected State Of Swatch To Active Selected after infinity scroll loaded products
  $(".swatch-container ul a").mouseleave(function (){
    $(this).children("div.selected_icon").addClass("hide_icon").removeClass("show_icon");
    $(".selected_icon").removeClass("hide_icon");
    $(".swatch-container ul a.active_picker").css("border","1px solid #212121");
    $(".swatch-container ul a.active_picker div").addClass("show_icon");
  });

  $(".swatch-container ul a.active_picker").mouseenter(function (){
    $(".swatch-container ul a.active_picker").css("border","1px solid #212121");
  });

  $(".swatch-container ul a.active_picker").mouseleave(function (){
    $(".swatch-container ul a.active_picker").css("border","1px solid #ffffff");
  });
}
  
// Collection infinity scroll pagination script
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    pagination: '#AjaxinatePagination',
    container: '#AjaxinateLoop ul',
    loadingText: 'Loading',
    callback: swatchcolor_change
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function () {
    var endlessScroll = new Ajaxinate({
      pagination: '#AjaxinatePagination',
      container: '#AjaxinateLoop ul',
      loadingText: 'Loading',
    });
  }, 3000);
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-collection-list"] && !Shopify.designMode) return;
  try {
    
var $OpticalarrivalSlider = $("#mobile-home-collection-list ul");

$(window).resize(function() {
  showOpticalarrivalSlider();
});

function showOpticalarrivalSlider() {
  if ($OpticalarrivalSlider.data("owlCarousel") !== "undefined") {
    if (window.matchMedia('(max-width: 1024px)').matches) {
      initialOpticalarrivalSlider();
    } else {
      destroyOpticalarrivalSlider();
    }
  }
}
showOpticalarrivalSlider();

function initialOpticalarrivalSlider() {
  $OpticalarrivalSlider.addClass("owl-carousel").owlCarousel({
    center: true,
    margin: 10,
    dots:true,
    loop: false,
    startPosition: 1,
    responsive:{
        0:{
            items:2
        },
    }
  });
}

function destroyOpticalarrivalSlider() {
  $OpticalarrivalSlider.trigger("destroy.owl.carousel").removeClass("owl-carousel");
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-home-new-arrivals"] && !Shopify.designMode) return;
  try {
    
var $NewarrivalSlider = $("#mobile-home-arrivals ul");

$(window).resize(function() {
  showNewArrivalSlider();
});

function showNewArrivalSlider() {
  if ($NewarrivalSlider.data("owlCarousel") !== "undefined") {
    if (window.matchMedia('(max-width: 1024px)').matches) {
      initialNewArrivalSlider();
    } else {
      destroyNewArrivalSlider();
    }
  }
}
showNewArrivalSlider();

function initialNewArrivalSlider() {
  $NewarrivalSlider.addClass("owl-carousel").owlCarousel({
    center: true,
    margin: 10,
    dots:true,
    loop: true,
    autoHeight:true,
    startPosition: 6,
    responsive:{
        0:{
            items:2,
            nav:true
        },
    }
  });
}

function destroyNewArrivalSlider() {
  $NewarrivalSlider.trigger("destroy.owl.carousel").removeClass("owl-carousel");
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
// Whole banner clickable script
// $(".top_video_section").click(function(){
//    window.location=$(this).find("a").attr("href"); 
//    return false;
// });

  } catch(e) { console.error(e); }
})();
})();
